<!-- User Engaging Loader - Show before streaming -->
<div class="loader-container" *ngIf="!showStreamingDots">
  <!-- Thinking header - Outside grey box -->
  <div class="thinking-header">
    <span class="thinking-title">{{ 'ENGAGING_LOADER.THINKING_TITLE' | translate }}</span>
    <span class="thinking-dots">
      <span class="thinking-dot thinking-dot-1">.</span>
      <span class="thinking-dot thinking-dot-2">.</span>
      <span class="thinking-dot thinking-dot-3">.</span>
    </span>
  </div>
  
  <!-- Timeline with dots and bullets -->
  <div class="thought-section">
    <!-- Dynamic timeline rows based on bulletCount -->
    <div class="timeline-row" 
         *ngFor="let bullet of bulletPointTexts.slice(0, bulletCount); let i = index"
         [class.hidden]="itemStates[i] === 'hidden'" 
         [class.active]="itemStates[i] === 'blinking'" 
         [class.inactive]="itemStates[i] === 'visible'">
      <div class="timeline-dot-wrapper">
        <div class="loader-dot"></div>
        <div class="loader-line" *ngIf="i < bulletCount - 1 && itemStates[i + 1] !== 'hidden'"></div>
      </div>
      <span class="thought-item" [class.blink]="itemStates[i] === 'blinking'">{{ bullet }}</span>
    </div>
  </div>
</div>

<!-- Three-dot streaming loader - Show during streaming -->
<div class="streaming-loader-container" *ngIf="showStreamingDots">
  <div class="dot-loader">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>
</div>

